import { render } from "./TheTemplateN.vue?vue&type=template&id=66e21f48&scoped=true&ts=true"
import script from "./TheTemplateN.vue?vue&type=script&lang=ts"
export * from "./TheTemplateN.vue?vue&type=script&lang=ts"

import "./TheTemplateN.vue?vue&type=style&index=0&id=66e21f48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e21f48"]])

export default __exports__